module.exports = __webpack_public_path__ + "img/companyfour.fd78a4f3.png";